import styled from 'styled-components'
import { Grid, media } from '../../components/layout'

export const SelectorWrapper = styled(Grid)`
  padding: 15px;
  ${media.lg} {
    padding: 20px 40px;
  }
`
